





































import { defineComponent } from '@vue/composition-api'
import { LocaleMessages } from 'vue-i18n'

export default defineComponent({
  name: 'InstagramMain',
  data() {
    return {
      profileName: ''
    }
  },
  computed: {
    labelProfileName(): string | LocaleMessages {
      return this.$t('feedGenerator.instagram.configuration.profileName')
    },
  },
  methods: {
    getValidationState(validation: { validated: boolean, valid: boolean | null }) {
      return validation.validated ? validation.valid : null
    },
    onSubmit() {
      console.dir('submit')
    },
  },
})

